// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3EtDD","dragIcon":"SortableItem_dragIcon__1jU22","disabled":"SortableItem_disabled__2S8qk"};